// All filter properties should be added here
export const ISSUE_FILTER_PROPERTIES = {
  ASSIGNED_TO_FILTER: 'assignedTo',
  CREATED_AT_END_FILTER: 'createdAtEnd',
  CREATED_AT_START_FILTER: 'createdAtStart',
  CREATED_BY_FILTER: 'createdBy',
  DUE_DATE_END_FILTER: 'dueDateEnd',
  DUE_DATE_START_FILTER: 'dueDateStart',
  STATUS_FILTER: 'status',
  SCHEDULE_IMPACT: 'schedule_impact',
  COST_IMPACT: 'cost_impact',
  PRIORITY: 'priority',
  DISCIPLINE: 'discipline',
  CATEGORY: 'category',
  SPEC_SECTION: 'specSection',
  INCLUDE_HIDDEN_FILTER: 'includeHiddenFilter',
  SEARCH: 'search',
  SEPARATOR: 'separator',
};

// If a query parameter is boolean, we need to add it to this list since it's used in query-helpers.
export const BOOLEAN_QUERY_PARAMS = [ISSUE_FILTER_PROPERTIES.INCLUDE_HIDDEN_FILTER];

export const ARRAY_QUERY_PARAMS = [
  ISSUE_FILTER_PROPERTIES.ASSIGNED_TO_FILTER,
  ISSUE_FILTER_PROPERTIES.CREATED_BY_FILTER,
  ISSUE_FILTER_PROPERTIES.STATUS_FILTER,
];

export const PAGE_PARAMS = {
  OFFSET: 'offset',
};

export const SORTING_PARAMS = {
  SORT: 'sort',
};
